import ReactGA from "react-ga4";

const TRACKING_ID = "G-T9FX196MJ8";

function init(): void {
  ReactGA.initialize(TRACKING_ID);
}

function sendEvent(name: string, params: Record<string, unknown>): void {
  ReactGA.event(name, params);
}


export default {
  init,
  sendEvent,
};
